/*
  第2b段の担当の節の CSS。担当の一覧は /Users/apple/Work/hp-renewal/v2/brief-phase2.md。
  色と余白は hp-base.ts の変数を使う。
*/
export const PHASE2B_CSS = `
/* 2b 共通。強調は青の1色。字の太さは本文のゴシックだけ使う */
.hp .hx-b-em{color:var(--blue)}
.hp .hx-b-p{margin-top:8px;font-size:14px;line-height:1.9;color:var(--ink)}
.hp .hx-b-p b{font-weight:700}
.hp .hx-b-tag{margin:16px 0 0;font-size:12px;font-weight:700;line-height:1.5;color:var(--blue)}
.hp .hx-b-h3{--font-body-ja:var(--mincho);margin:6px 0 0;font-weight:700;font-size:19px;line-height:1.6;letter-spacing:.01em;word-break:auto-phrase}

/* BuiltByUs。節の余白と映像の高さを詰めて、1画面に近い高さにする */
.hp .hx-sec:has(.hx-b-grid){--sec:32px;--gap:16px}
.hp .hx-b-p{margin-top:6px;line-height:1.8}
.hp .hx-b-text .hx-b-h3{font-size:18px;line-height:1.5}
.hp .hx-b-grid{display:grid;gap:20px;margin-top:var(--gap)}
.hp .hx-b-media,.hp .hx-b-text,.hp .hx-b-item{min-width:0}
.hp .hx-b-media .hx-frame video,.hp .hx-b-media .hx-frame img{display:block;width:100%;height:auto;max-height:160px;object-fit:cover}
.hp .hx-b-media .vjs-tech,.hp .hx-b-media .vjs-poster img{object-fit:cover}
.hp .hx-b-media .vjs-poster{background-size:cover}
.hp .hx-b-media .vjs-yumesaku{height:160px}
.hp .hx-b-media .vjs-fluid:not(.vjs-audio-only-mode),.hp .hx-b-media .video-js{height:100%;max-height:none;padding-top:0}
.hp .hx-b-wide{display:grid;gap:12px;margin-top:12px;padding-top:12px;border-top:1px solid var(--ink)}
.hp .hx-b-wide-c{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;gap:12px 24px}
.hp .hx-b-wide .hx-b-tag{margin-top:0}
.hp .hx-b-text .hx-b-item .hx-b-tag{margin-top:0}
@media (min-width:700px){
  .hp .hx-b-grid{grid-template-columns:minmax(0,1fr) minmax(0,300px);column-gap:32px;align-items:center}
  .hp .hx-b-media{order:2}
  .hp .hx-b-media .hx-frame video,.hp .hx-b-media .hx-frame img{max-height:none}
  .hp .hx-b-media .vjs-yumesaku{height:auto}
  /* 枠を取るのは video.js が組んだ div だけ。乗る前の素の video に当てると、乗った瞬間に高さが変わって下がずれる */
  .hp .hx-b-media .vjs-fluid:not(.vjs-audio-only-mode),.hp .hx-b-media div.video-js{height:auto;padding-top:75%}
}
@media (min-width:900px){
  .hp .hx-sec:has(.hx-b-grid){--sec:56px;--gap:32px}
  .hp .hx-b-grid{grid-template-columns:minmax(0,1fr) minmax(0,440px);column-gap:56px;align-items:center}
  .hp .hx-b-media{order:2}
  .hp .hx-b-media .hx-frame video,.hp .hx-b-media .hx-frame img{max-height:none}
  .hp .hx-b-text .hx-b-h3{font-size:20px}
}

/* InstructorEditorial */
.hp .hx-i-grid{display:grid;grid-template-columns:1fr 1fr;gap:32px 16px;margin-top:var(--gap)}
.hp .hx-i-card{min-width:0}
.hp .hx-i-photo{position:relative;aspect-ratio:3/4;overflow:hidden;border:1px solid var(--ink);border-radius:6px;background:var(--cream)}
.hp .hx-i-photo>img{display:block;width:100%;height:100%;object-fit:cover;object-position:top;filter:grayscale(1);transition:filter var(--m-cta) var(--m-out)}
.hp .hx-i-card:hover .hx-i-photo>img{filter:none}
.hp .hx-i-over{position:absolute;left:0;right:0;bottom:0;padding:48px 10px 10px;background:linear-gradient(to top,rgba(14,14,16,.88),rgba(14,14,16,.55) 60%,rgba(14,14,16,0))}
.hp .hx-i-read{--font-body-ja:var(--mono);margin:0;font-size:12px;font-weight:400;letter-spacing:.02em;line-height:1.4;color:rgba(255,255,255,.86)}
.hp .hx-i-name{--font-body-ja:var(--mincho);margin:2px 0 0;font-weight:700;font-size:16px;line-height:1.4;color:#fff}
.hp .hx-i-role{display:inline-block;margin-top:6px;padding:3px 8px;border-radius:4px;background:#fff;font-size:12px;font-weight:700;line-height:1.3;color:var(--ink)}
.hp .hx-i-topics{display:flex;flex-wrap:wrap;gap:4px;margin-top:6px}
.hp .hx-i-topics span{padding:2px 6px;border:1px solid rgba(255,255,255,.6);border-radius:4px;font-size:12px;font-weight:700;line-height:1.4;color:#fff}
.hp .hx-i-facts>div{display:flex;gap:8px;padding:5px 0;border-top:1px solid rgba(255,255,255,.28)}
.hp .hx-i-facts dt{flex:none;display:flex;align-items:flex-start;gap:3px;width:calc(2.6em + 17px);font-size:12px;font-weight:700;line-height:1.6;color:rgba(255,255,255,.78)}
.hp .hx-i-fic{flex:none;margin-top:.15em;color:#fff;--icon-paper:transparent}
.hp .hx-i-facts dd{min-width:0;margin:0;word-break:keep-all;overflow-wrap:break-word;font-size:12px;font-weight:700;line-height:1.6;color:#fff}
.hp .hx-i-note{display:block;margin-top:2px;font-size:12px;font-weight:400;line-height:1.5;color:rgba(255,255,255,.82)}
/* 経歴の面。閉じている間は高さ0で切るだけ (中身は HTML と読み上げに残る)。
   開くと名前の塊が面ごと上へ押し上がる。ページの高さは変わらない (写真の中で動く) */
.hp .hx-i-over{isolation:isolate}
.hp .hx-i-over::before{content:"";position:absolute;inset:0;z-index:-1;background:rgba(14,14,16,.94);opacity:0;transition:opacity 300ms var(--m-out)}
.hp .hx-i-pane{display:grid;grid-template-rows:0fr;transition:grid-template-rows 300ms var(--m-out)}
.hp .hx-i-facts{min-height:0;margin:0;overflow:hidden}
.hp .hx-i-facts>div:first-child{margin-top:8px}
.hp .hx-i-card{outline:none}
.hp .hx-i-card:focus-visible .hx-i-photo{outline:2px solid var(--focus-ring);outline-offset:2px}
/* 開いたとき。上の余白を詰め、狭いカードでは名前だけ残して役職と得意分野を畳む (経歴が写真に収まらないため) */
.hp .hx-i-over{display:flex;flex-direction:column;justify-content:flex-end;align-items:flex-start;min-height:0;transition:padding-top 300ms var(--m-out),min-height 300ms var(--m-out)}
.hp .hx-i-over>*{flex:none}
.hp .hx-i-pane{align-self:stretch}
@media (hover:hover){
  .hp .hx-i-card:hover .hx-i-over::before,.hp .hx-i-card:focus-visible .hx-i-over::before{opacity:1}
  .hp .hx-i-card:hover .hx-i-over,.hp .hx-i-card:focus-visible .hx-i-over{padding-top:12px}
  .hp .hx-i-card:hover .hx-i-pane,.hp .hx-i-card:focus-visible .hx-i-pane{grid-template-rows:1fr}
  .hp .hx-i-card:focus-visible .hx-i-photo>img{filter:none}
}
@media (hover:none){
  .hp .hx-i-card[data-open] .hx-i-over::before,html:not(.hx-i-js) .hp .hx-i-card:focus .hx-i-over::before{opacity:1}
  .hp .hx-i-card[data-open] .hx-i-over,html:not(.hx-i-js) .hp .hx-i-card:focus .hx-i-over{padding-top:12px}
  .hp .hx-i-card[data-open] .hx-i-pane,html:not(.hx-i-js) .hp .hx-i-card:focus .hx-i-pane{grid-template-rows:1fr}
  .hp .hx-i-card[data-open] .hx-i-photo>img{filter:none}
}
@media (max-width:1099px){
  .hp .hx-i-facts dd,.hp .hx-i-facts dt{font-size:12px;line-height:1.5}
  /* 写真が小さい幅でも、図記号と見出しは1行に並べ、見出しの列は全行で同じ幅にする。値は全行が同じ x から、見出しと同じ高さで始まる */
  .hp .hx-i-facts dt{width:calc(2em + 17px);gap:2px}
  .hp .hx-i-fic{margin-top:2px}
  .hp .hx-i-note{font-size:12px}
  .hp .hx-i-facts>div{padding:4px 0}
}
@media (max-width:1099px) and (hover:hover){
  .hp .hx-i-card:hover .hx-i-over,.hp .hx-i-card:focus-visible .hx-i-over{min-height:100%}
  .hp .hx-i-card:hover :is(.hx-i-read,.hx-i-role,.hx-i-topics),.hp .hx-i-card:focus-visible :is(.hx-i-read,.hx-i-role,.hx-i-topics){display:none}
}
@media (max-width:1099px) and (hover:none){
  .hp .hx-i-card[data-open] .hx-i-over,html:not(.hx-i-js) .hp .hx-i-card:focus .hx-i-over{min-height:100%}
  .hp .hx-i-card[data-open] :is(.hx-i-read,.hx-i-role,.hx-i-topics),html:not(.hx-i-js) .hp .hx-i-card:focus :is(.hx-i-read,.hx-i-role,.hx-i-topics){display:none}
}
/* スマホの幅は写真が小さく、経歴の長い人 (小澤) は開いても収まらない。字を少し詰め、それでも溢れたら面の中でスクロールする。
   上から並べるのは、下揃えのまま溢れると上の名前までスクロールで戻れなくなるため */
@media (max-width:480px){
  .hp .hx-i-facts dd,.hp .hx-i-facts dt{font-size:12px;line-height:1.45}
  .hp .hx-i-facts>div{padding:3px 0}
  .hp .hx-i-card[data-open] .hx-i-over,html:not(.hx-i-js) .hp .hx-i-card:focus .hx-i-over{max-height:100%;overflow-y:auto;overscroll-behavior:contain;justify-content:flex-start}
}
@media (prefers-reduced-motion:reduce){
  .hp .hx-i-over,.hp .hx-i-over::before,.hp .hx-i-pane{transition:none}
}
.hp .hx-i-crit{margin-top:var(--gap);padding-top:24px;border-top:1px solid var(--ink)}
/* 審査基準の札。600px 以上は3枚を横に並べる。数字は等幅で大きく、中身は小さく。
   スマホの幅で3列にすると1列が 100px ほどになり、中身が「現役エン / ジニアま」のように 3〜4 字ずつ折れるので、縦に積んで札の中を横に組む */
.hp .hx-i-crit-l{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin:16px 0 0;padding:0;list-style:none}
.hp .hx-i-crit-l li{display:grid;justify-items:start;align-content:start;gap:4px;padding:12px 8px;min-width:0;border:1px solid var(--ink);border-radius:6px;background:#fff}
.hp .hx-i-crit-ic{--icon-paper:#fff;flex:none;color:var(--ink)}
.hp .hx-i-crit-n{--font-body-ja:var(--mono);font-weight:600;font-size:clamp(16px,5vw,28px);letter-spacing:-.04em;line-height:1.15;white-space:nowrap}
.hp .hx-i-crit-t{min-width:0;font-size:12px;font-weight:700;line-height:1.6;overflow-wrap:anywhere;word-break:auto-phrase;text-wrap:pretty}
.hp .hx-i-crit-f{--font-body-ja:var(--mincho);margin:0;word-break:keep-all;text-wrap:balance;font-weight:700;font-size:18px;line-height:1.6}
@media (max-width:599px){
  .hp .hx-i-crit-l{grid-template-columns:minmax(0,1fr)}
  .hp .hx-i-crit-l li{grid-template-columns:auto minmax(0,1fr);column-gap:12px;padding:12px 14px}
  .hp .hx-i-crit-ic{grid-row:1/3}
}
@media (min-width:900px){
  .hp .hx-i-grid{grid-template-columns:repeat(4,minmax(0,1fr));gap:24px}
  .hp .hx-i-crit-l{gap:24px}
  .hp .hx-i-crit-l li{grid-template-columns:auto minmax(0,1fr);column-gap:12px;padding:18px 20px}
  .hp .hx-i-crit-ic{grid-row:1/3}
  .hp .hx-i-crit-n{font-size:34px}
  .hp .hx-i-crit-t{font-size:14px}
}

/* WorkingEngineers */
.hp .hx-w-grid{display:grid;gap:32px;margin-top:var(--gap)}
.hp .hx-w-l,.hp .hx-w-r{min-width:0}
.hp .hx-w-name{margin:16px 0 0;font-size:15px;font-weight:700}
.hp .hx-w-sub{margin:2px 0 0;font-size:12px;color:var(--sub)}
.hp .hx-w-more{display:inline-flex;align-items:center;gap:6px;margin-top:16px;font-size:13px}
.hp .hx-w-r>.hx-qi:first-child{border-top:1px solid var(--ink)}
@media (min-width:900px){
  .hp .hx-w-grid{grid-template-columns:minmax(0,46%) minmax(0,1fr);column-gap:56px;align-items:start}
}

`;
